import * as moment from 'moment';
import { FileDocumentType } from '@nkr/enums/index';
import { IWatrRequest } from '@nkr/models/index';
import { Alert, Col, Panel, Row } from 'react-bootstrap'
import { useContext } from 'react';
import { DonorShieldContext } from '../context';
import WeekByWeekBreakdown from '../common/week-by-week-breakdown';

interface IProps {
    data: IWatrRequest,
    incomePercentCovered: number,
    hasPayStub: boolean,
    hasTaxFile: boolean,
    allowEditWeekOtherAmount?: boolean,
    onWeekOtherAmountChange?: (weekRequested: number, otherAmount: number) => void,
    draftWeekOtherAmounts?: Record<number, number>,
    onSaveWeekOtherAmount?: (weekRequested: number, otherAmount: number) => void | Promise<void>,
    savingWeekRequested?: number | null,
    saveError?: string | null
}

const Wages = (props: IProps) => {
    const context = useContext(DonorShieldContext);

    const downloadFile = async (docType: FileDocumentType, lookupId: number) => {
        let fileUrl = await context.fetchFileUrl(docType, lookupId);

        context.onShowDataSideBar(docType, lookupId, fileUrl);
    };

    return (
        <Panel eventKey='2'>
            <Panel.Heading style={{ paddingTop: 5, paddingBottom: 5 }}>
                <Panel.Title toggle style={{ fontSize: 14 }}>Wages</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
                <Row>
                    <Col xs={12} md={10} lg={10} style={{ fontWeight: 500 }}>LWR:</Col>
                    <Col xs={12} md={2} lg={2}>${props.data.lwr == undefined ? 0.00 : Math.round(props.data.lwr).toLocaleString()}</Col>
                </Row>

                <Row>
                    <Col xs={12} md={10} lg={10} style={{ fontWeight: 500 }}>Total Reimbursed:</Col>
                    <Col xs={12} md={2} lg={2}>${props.data.wagesReimbursed == undefined ? 0.00 : Math.round(props.data.wagesReimbursed).toLocaleString()}</Col>
                </Row>

                <Row>
                    <Col xs={12} md={10} lg={10} style={{ fontWeight: 500 }}>Reimbursement Rate:</Col>
                    <Col xs={12} md={2} lg={2}>${props.data.reimbursementRate == undefined ? 0.00 : props.data.reimbursementRate.toFixed(2)}</Col>
                </Row>

                <Row>
                    <Col xs={12} md={10} lg={10} style={{ fontWeight: 500 }}>Reimbursement Amount:</Col>
                    <Col xs={12} md={2} lg={2}>${props.data.reimbursementAmount == undefined ? 0.00 : Math.round(props.data.reimbursementAmount).toLocaleString()}</Col>
                </Row>

                <Row>
                    <Col xs={12} md={10} lg={10} style={{ fontWeight: 500 }}>Income Percent Covered:</Col>
                    <Col xs={12} md={2} lg={2}>{props.incomePercentCovered}%</Col>
                </Row>

                <WeekByWeekBreakdown
                    data={props.data}
                    allowEditOtherAmount={props.allowEditWeekOtherAmount}
                    onOtherAmountChange={props.onWeekOtherAmountChange}
                    draftOtherAmounts={props.draftWeekOtherAmounts}
                    onSaveOtherAmount={props.onSaveWeekOtherAmount}
                    savingWeekRequested={props.savingWeekRequested}
                    saveError={props.saveError}
                />

                {props.data.additionalDetails &&
                    <Alert bsStyle='info' bsSize='sm' style={{ marginTop: 15 }}>
                        <div style={{ fontWeight: 500 }}>Additional Details:</div>
                        <div>{props.data.additionalDetails}</div>
                    </Alert>
                }

                <Row>
                    <Col xs={6} md={6} lg={6}>
                        {props.hasTaxFile &&
                            <a className='btn btn-default form-control'
                                onClick={() => downloadFile(FileDocumentType.Tax, props.data.id)}>
                                View Tax
                            </a>
                        }

                        {!props.hasTaxFile &&
                            <div className='bg-warning' style={{ textAlign: 'center', padding: 5, borderRadius: 4 }}>
                                <strong>Tax File Pending</strong>
                            </div>
                        }
                    </Col>

                    <Col xs={6} md={6} lg={6}>
                        {props.hasPayStub &&
                            <a className='btn btn-default form-control'
                                onClick={() => downloadFile(FileDocumentType.PayStub, props.data.id)}>
                                View Pay Stub
                            </a>
                        }

                        {!props.hasPayStub && props.data.requireSelfEmployedAffirmation == false &&
                            <div className='bg-warning' style={{ textAlign: 'center', padding: 5, borderRadius: 4 }}>
                                <strong>Pay Stub Pending</strong>
                            </div>
                        }
                    </Col>
                </Row>
            </Panel.Body>
        </Panel>
    );
}

export default Wages;